import {

  addDoc,
  collection,
  serverTimestamp

} from "../access/firestore";

import {
  auth,
  db
} from "../firebase";

export default async function logAction({

  clinicId,
  action,
  module,
  targetId = "",
  targetName = "",
  extra = {}

}) {

  try {

    const user =
      auth.currentUser;

    if (!user) return;

    const userSnap =
      await fetchUserData(
        user.uid
      );

    await addDoc(

      collection(
        db,
        "clinics",
        clinicId,
        "logs"
      ),

      {

        userId:
          user.uid,

        userName:
          userSnap?.nombre ||
          user.displayName ||
          user.email ||
          "VexaDent / Sistema",

        userEmail:
          user.email || "",

        action,

        module,

        targetId,

        targetName,

        extra,

        createdAt:
          serverTimestamp()

      }

    );

  } catch(err) {

    console.error(
      "Error creando log:",
      err
    );

  }

}

async function fetchUserData(uid) {

  const {

    doc,
    getDoc

  } = await import(
    "firebase/firestore"
  );

  const snap =
    await getDoc(

      doc(
        db,
        "users",
        uid
      )

    );

  if (snap.exists()) {

    return snap.data();

  }

  return null;

}
